export default __webpack_public_path__ + "static/media/about-us.2bbac81b.png";